<div class="new-options__overlay d-block d-md-none" [class.opened] = 'opened'>
  <a (click)="close()" href="javascript:void(0)" class="record__close"><i class="icon-close"></i></a>
  <ul class="new-options__overlaylist">
    <li class="disabled">Options</li>
    <li *ngFor="let l of list" (click)="send(l)">{{l}}</li>
  </ul>
</div>